import {
  DOWNLOAD_GET_SOFT_LIST_SUCCESS,
  DOWNLOAD_UPDATE_SOFT_LIST_STATE,
  DOWNLOAD_UPDATE_SOFT_LIST_PROGRESS,
  DOWNLOAD_SHOW_FILE_ERROR,
  DOWNLOAD_SHOW_SIM,
  DOWNLOAD_CANENL,
} from '../constants/downloadTask';
import { PCStoreJsBridge } from '../nativeapi';
import { logNative } from '../utils/utils';

const initState = {
  softs: [],
  showFileError: {
    show: false,
    time: 0,
  },
  showSIM: '',
  downloadCanelShow: {
    isShow: false,
  },
};

const downloadTask = (state = initState, action = {}) => {
  let softList = [];
  switch (action.type) {
    case DOWNLOAD_SHOW_FILE_ERROR:
      return { ...state, showFileError: action.payload };
    case DOWNLOAD_SHOW_SIM:
      // showSIM === SIM_64
      // showSIM === SIM_Need_Restart
      return { ...state, showSIM: action.payload };
    case DOWNLOAD_GET_SOFT_LIST_SUCCESS:
      return { ...state, softs: action.payload };
    case DOWNLOAD_UPDATE_SOFT_LIST_STATE:
      state.softs.some(v => {
        if (
          (action.param.type === 'apk' && v.type === 'apk' && action.param.apk.pkg === v.apk.pkg) ||
          (action.param.type === 'pc' && v.type === 'pc' && action.param.pc.SoftID === v.pc.SoftID)
        ) {
          const tmpObj = v;
          tmpObj.attr = {
            ...tmpObj.attr,
            ...action.param.attr,
          };
          if (action.param.BizInfo) {
            tmpObj.BizInfo = action.param.BizInfo;
          }
          return true;
        }
        return false;
      });

      if (action?.param?.attr?.statFrom == 'dl' && action?.param?.attr?.eCode === -42003) {
        logNative(`下载任务失败，下载路径不存在 ${JSON.stringify(action?.param)}`);
        let show = false;
        // 上次没有弹出  或者上次弹出离现在已经过去一分钟  就再次弹出
        if (!state?.showFileError?.time || +new Date() - state?.showFileError?.time > 60 * 1000) {
          show = true;
        }
        return {
          ...state,
          softs: [...state.softs],
          showFileError: { ...state.showFileError, show: show },
        };
      }
      return { ...state, softs: [...state.softs] };
    case DOWNLOAD_UPDATE_SOFT_LIST_PROGRESS:
      state.softs.some(v => {
        if (
          (action.param.type === 'apk' && v.type === 'apk' && action.param.apk.pkg === v.apk.pkg) ||
          (action.param.type === 'pc' && v.type === 'pc' && action.param.pc.SoftID === v.pc.SoftID)
        ) {
          const tmpObj = v;
          tmpObj.attr = { ...tmpObj.attr, ...action.param.attr };
          if (action.param.BizInfo) {
            tmpObj.BizInfo = action.param.BizInfo;
          }
          return true;
        }

        return false;
      });
      return { ...state, softs: [...state.softs] };
    case DOWNLOAD_CANENL:
      return {
        ...state,
        downloadCanelShow: { ...action.payload },
      };
    default:
      return state;
  }
};

export default downloadTask;
